import loadable from "@/utils/loadable";

export default loadable(() => import("./book-house"));
